const Iframe = ({
    type,
    sectionId,
    colorScheme,
    url,
    iframeLabel,
    height
  }) => {
    const normalizedData = {
      type,
      sectionId,
      colorScheme,
      url,
      iframeLabel,
      height
    }
  
    return normalizedData
  }
  
  export default Iframe
  